<template>
    <label :for="`file${props.index}`" class="label px-3 text-uppercase">
      {{ t("points.boosterCCS.file") }}
    </label>

    <input
        type="file"
        class="d-none"
        :id="`file${props.index}`"
        :name="`file${props.index}`"
        @change="onFileChange"
        ref="fileInputRef"
    />

    <button
        type="button"
        class="btn d-flex border p-0 bg-white w-100"
        @click="fileInputRef.click()"
    >
      <span class="d-block input-file-text p-2">{{t("points.chooseFile")}}</span>
      <span class="d-block p-2 text-black">{{selectedFileName || t("points.notFoundFile")}}</span>
    </button>

    <ErrorMessage :name="`file${props.index}`" class="text-danger text-small text-end m-0 pt-1" />
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import {ErrorMessage} from "vee-validate";

const props = defineProps({
  index: {
    type: Number,
    required: true
  }
})

const { t } = useI18n()

const selectedFileName = ref('')
const fileInputRef = ref(null)

const emit = defineEmits(['change'])

const onFileChange = (event) => {
  const file = event.target.files[0]
  if (file) {
    selectedFileName.value = file.name
    emit('change', event)
  }
}
</script>

<style scoped>
.input-file-text{
  border-right: 3px solid #d9d9d9;
}
</style>